module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "CN ParaOverride-1",
    attrs: {
      "id": "_idParaDest-3"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer001"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/1979TitleType1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Full-out ParaOverride-5"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/L-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Full-out ParaOverride-6"
  }, [_vm._v("Atlantic Mon"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("thly Press")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Full-out ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("New York")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60e501d3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780802159038-2.vue
// module id = 69
// module chunks = 0